import { FilterItem } from '@wconcept/wconcept-common/models/renewal/common';
import Box from '@wconcept/wconcept-ui-renewal/components/atoms/Box';
import FltChkItem from '@wconcept/wconcept-ui-renewal/components/molecules/_item/FltChkItem';
import FltBenefitBox from '../../_list/FltBenefitBox';

function StyleContent({
  styleList,
  isItemSelected,
  onChangeStyle,
}: {
  styleList?: FilterItem[] | null;
  isItemSelected: (filterType: string, item: FilterItem) => boolean;
  onChangeStyle: (style: FilterItem) => void;
}) {
  if (!styleList) {
    return null;
  }

  return (
    <Box className="coner-style">
      <FltBenefitBox
        items={styleList?.map((style: FilterItem) => (
          <FltChkItem
            key={style.code}
            value={style.code}
            checked={isItemSelected('style', style)}
            name={style.name}
            cnt={style.count}
            onChange={() => onChangeStyle(style)}
          />
        ))}
      />
    </Box>
  );
}

export default StyleContent;
